/* eslint-disable eol-last */
// java 涂工接口
import request from '@/utils/home/report'
// 汇总报表   生产报表 begin
export function workorderSum(query) {
  return request({
    url: '/api/report/mt/api/workorder/workorderSum',
    method: 'get',
    params: query
  })
}
// 日生产报表
export function workorder(query) {
  return request({
    url: '/api/report/mt/api/workorder/workorder',
    method: 'get',
    params: query
  })
}
// 日排产报表
export function productionworkorder(query) {
  return request({
    url: '/api/report/mt/api/workorder/productionworkorder',
    method: 'get',
    params: query
  })
}
// 排产报表修改
export function insertorupdate(data) {
  return request({
    url: '/api/report/mt/api/workorder/insertorupdate',
    method: 'post',
    data
  })
}
// 排产报表列删除
export function deleteproductionrate(data) {
  return request({
    url: '/api/report/mt/api/workorder/deleteproductionrate',
    method: 'post',
    data
  })
}
// 订单统计报表   生产报表end
export function orderno(query) {
  return request({
    url: '/api/report/mt/api/workorder/orderno',
    method: 'get',
    params: query
  })
}
// 追溯码发放查询   物流报表begin
export function codefind(query) {
  return request({
    url: '/api/report/mt/api/qrcodeorder/find',
    method: 'get',
    params: query
  })
}
// 追溯码人工申请表
export function findArtificial(query) {
  return request({
    url: '/api/report/mt/api/qrcodeorder/findArtificial',
    method: 'get',
    params: query
  })
}
// 菲尼克斯退货
export function findRejected(query) {
  return request({
    url: '/api/report/mt/api/rejectedlog/findRejected',
    method: 'get',
    params: query
  })
}
// 市场监察报表
export function check(query) {
  return request({
    url: '/api/report/mt/api/check/check',
    method: 'get',
    params: query
  })
}
// 仓库发货端报表
export function orderandworkproducts(query) {
  return request({
    url: '/api/report/mt/api/order/orderandworkproducts',
    method: 'get',
    params: query
  })
}
// 成品交接单
export function producehandover(query) {
  return request({
    url: '/api/report/mt/api/workorder/producehandover',
    method: 'get',
    params: query
  })
}
// 首页图表接口
// 扫码次数
export function scancount(data) {
  return request({
    url: '/api/report/mt/api/report/scancount',
    method: 'post',
    data
  })
}
// 窜货区域
export function insepctmap(data) {
  return request({
    url: '/api/report/mt/api/report/insepctmap',
    method: 'post',
    data
  })
}
export function insepctmapcity(data) {
  return request({
    url: '/api/report/mt/api/report/insepctmapcity',
    method: 'post',
    data
  })
}
// 生产数量
export function productioncount(data) {
  return request({
    url: '/api/report/mt/api/report/productioncount',
    method: 'post',
    data
  })
}
// 退货数量
export function returncount(data) {
  return request({
    url: '/api/report/mt/api/report/returncount',
    method: 'post',
    data
  })
}
// 发货数量
export function sendcount(data) {
  return request({
    url: '/api/report/mt/api/report/sendcount',
    method: 'post',
    data
  })
}
// 供应商生码数量
export function suppsendqrcode(data) {
  return request({
    url: '/api/report/mt/api/report/suppsendqrcode',
    method: 'post',
    data
  })
}